import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import CompassBanner from "../Tools/CompassBanner";
import { Chart, registerables } from "chart.js"
import { LineChart, Line, XAxis, YAxis, ZAxis, CartesianGrid, Tooltip, Legend, Label, Scatter, ScatterChart, ResponsiveContainer, ReferenceLine } from 'recharts';
import CompassLogo from "../Tools/CompassLogo";

const EductorBlank = () => {

	const { id } = useParams();
	const [user, setUser] = useContext(UserContext);
	let navigate = useNavigate();
	CheckToken(user["id"], user["token"]).then((result) => { if (!result) { localStorage.clear(); setUser({}); navigate("/Login") } });

	const getToday = (e) => {

		const today = new Date();
		const month = String(today.getMonth() + 1).padStart(2, '0');
		const day = String(today.getDate()).padStart(2, '0');
		const year = String(today.getFullYear());

		return `${month}/${day}/${year}`;

	};

	const handlePrint = () => {
		window.print();
	};

	const TestBox = (props) => {
		return (
			<>
				<table className="no-break" style={{ border: "1px solid black", width: "100%", marginTop: "24px" }}>
					<tbody>

						<tr style={{ width: "100%", display: "flex", flexDirection: "row" }}>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly", fontWeight: "bold", textDecoration: "underline" }}>TEST# {props.testnumber}</td>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>{props.percentage}% Open</td>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>________" Diameter</td>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>________" Inner Diameter</td>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>____________" Thick</td>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>________" Area (intake side)</td>
						</tr>

						<tr style={{ width: "100%", display: "flex", flexDirection: "row" }}>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>Static Pressure: ____________ H₂O</td>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>Avg√VP: ____________</td>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>Velocity: ____________ FPM</td>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>CFM: ____________</td>
						</tr>

						<tr style={{ width: "100%", display: "flex", flexDirection: "row" }}>
							{[...Array(11)].map((_, i) => (
								<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", fontWeight: "bold" }} key={i}>
									<span>{`VP${i + 1}`}:</span> <span>______</span>
								</td>
							))}
						</tr>

						<tr style={{ width: "100%", display: "flex", flexDirection: "row" }}>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>Notes: </td>
						</tr>
					</tbody>
				</table>
			</>
		);
	}

	document.title = `Eductor - Blank Test Form`;
	return (
		<>

			<div className="body-content" style={{ marginTop: "25px", width: "1100px", margin: "auto" }}>

				<div className="no-print" style={{ marginBottom: "8px" }}>
					<Link to={`/Eductor`} className="btn btn-default" style={{ width: "132px" }}>Back</Link>
					<button onClick={handlePrint} className="btn btn-primary" style={{ width: "132px", marginLeft: "8px" }}>Print This Page</button>
				</div>

				<div style={{ border: "1px solid black", textAlign: "center", padding: "8px" }}>
					{/* <CompassBanner /> */}
					<CompassLogo />
				</div>

				<div style={{ color: "lightgray" }}>
					<i>Template generated on {getToday()}</i>
				</div>

				<div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>

					<h3>Venturi Eductor Unit Performance Results</h3>
					<span style={{ color: "red", fontWeight: "bold" }}><i>[CONFIDENTIAL]</i></span>

				</div>

				<div>
					<table className="no-break" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>

						<tr style={{ border: "1px solid black", width: "100%", display: "flex", flexDirection: "row" }}>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
								<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "8px" }}>
									<span style={{ color: "var(--bs-secondary)", fontWeight: "bold" }}>Eductor Model Name </span>
									<i style={{ opacity: "0.5" }}> (Ex: <span style={{ textDecoration: "underline" }}>ED - 6 X 8 - 5HP)</span></i>
									<span style={{ color: "var(--bs-secondary)", fontWeight: "bold" }}>:</span>
								</div>
								<span style={{ marginLeft: "8px" }}>____________________________________</span>
							</td>
						</tr>

						<tr style={{ border: "1px solid black", width: "100%", display: "flex", flexDirection: "row" }}>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Model (Ext.): </span><span style={{ marginLeft: "8px" }}>____________________________________</span></td>
						</tr>

						<tr style={{ border: "1px solid black", width: "100%", display: "flex", flexDirection: "row" }}>
							<td style={{ border: "1px solid black", padding: "8px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Fan Model Name: </span><span style={{ marginLeft: "8px" }}>____________________________________</span></td>
						</tr>

						<tr style={{ border: "1px solid black", width: "100%", display: "flex", flexDirection: "row" }}>
							<td style={{ border: "1px solid black", padding: "8px", width: "50%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Job Number: </span><span style={{ marginLeft: "8px" }}>________________________</span></td>
							<td style={{ border: "1px solid black", padding: "8px", width: "50%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Date Completed: </span><span style={{ marginLeft: "8px" }}>________________________</span></td>
						</tr>

						<tr style={{ border: "1px solid black", width: "100%", display: "flex", flexDirection: "row" }}>
							<td style={{ border: "1px solid black", padding: "8px", width: "50%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Customer Name: </span><span style={{ marginLeft: "8px" }}>________________________</span></td>
							<td style={{ border: "1px solid black", padding: "8px", width: "50%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>QuoteNumber: </span><span style={{ marginLeft: "8px" }}>________________________</span></td>
							<td style={{ border: "1px solid black", padding: "8px", width: "33.4%", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}><span style={{ fontWeight: "bold" }}>Sketch Number: </span><span style={{ marginLeft: "8px" }}>________________________</span></td>
						</tr>

					</table>
				</div>

				<div className="no-break" style={{ border: "2px solid black", textAlign: "left", padding: "4px", marginTop: "24px" }}>

					<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "8px" }}>
						<h5 style={{ textDecoration: "underline", marginLeft: "8px", fontWeight: "bold" }}>CALCULATED SYSTEM PERFORMANCE</h5>
						<i style={{ opacity: "0.5" }}>(FROM DESIGN CONFIGURATOR SYSTEM DESIGN SHEET)</i>
					</div>

					<div style={{ textAlign: "left", padding: "4px", display: "flex", flexDirection: "row", margin: "auto", justifyContent: "space-between" }}>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>INDUCED AIRFLOW: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>INLET STATIC PRESSURE: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>DISCHARGE STATIC PRESSURE: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

					</div>
				</div>

				<div className="no-break" style={{ border: "2px solid black", textAlign: "left", padding: "4px" }}>

					<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "8px" }}>
						<h5 style={{ textDecoration: "underline", marginLeft: "8px", fontWeight: "bold" }}>BLOWER SELECTION PERFORMANCE REQUIREMENTS</h5>
						<i style={{ opacity: "0.5" }}>(FROM BLOWER VENDOR PERFORMANCE SHEETS OR QUOTE)</i>
					</div>

					<div style={{ textAlign: "left", padding: "4px", display: "flex", flexDirection: "row", margin: "auto", justifyContent: "space-between" }}>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>AIRFLOW (ACFM): </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>INTERNAL PO NUMBER: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>INLET STATIC PRESSURE: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>CALCULATED BHP: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>DISCHARGE STATIC PRESSURE: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>DATE COMPLETED: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

					</div>
				</div>

				<div className="no-break" style={{ border: "2px solid black", textAlign: "left", padding: "4px" }}>
					<h5 style={{ textDecoration: "underline", marginLeft: "8px", fontWeight: "bold" }}>ACTUAL PERFORMANCE RESULTS</h5>
					<div style={{ textAlign: "left", padding: "4px", display: "flex", flexDirection: "row", margin: "auto", justifyContent: "space-between" }}>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>ACTUAL PLENUM PRESSURE: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>STATIC CLOSED OFF: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR RPM: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>CALCULATED BLOWER AIR FLOW: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>PLENUM TYPE: </span><span style={{ marginLeft: "8px" }}>▢ WINGED&nbsp;&nbsp;▢ STRAIGHT</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>NOZZLE SETTING: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>NOZZLE TIGHTNESS: </span><span style={{ marginLeft: "8px" }}>▢ TIGHT&nbsp;&nbsp;▢ LOOSE</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR VOLTAGE: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>INTAKE SILENCER: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR AMPS 1: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR AMPS 2: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR AMPS 3: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR AMPS AVG: </span><span style={{ marginLeft: "8px" }}>____________</span></li>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>MOTOR AMP RATING: </span><span style={{ marginLeft: "8px" }}>____________</span></li>

						</ol>

					</div>

				</div>

				<div className="no-break" style={{ border: "2px solid black", textAlign: "left", padding: "4px" }}>
					<h5 style={{ textDecoration: "underline", marginLeft: "8px", fontWeight: "bold" }}>AIR PROPERTIES DURING TEST</h5>
					<div style={{ textAlign: "left", padding: "4px", display: "flex", flexDirection: "row", margin: "auto", justifyContent: "space-between" }}>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>AIR TEMPERATURE (°F): </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>HUMIDITY (%): </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>AIR PRESSURE (inHg): </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

						<ol style={{ marginRight: "16px" }}>
							<li style={{ padding: "4px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}><span style={{ fontWeight: "bold" }}>AIR DENSITY (lb/ft³): </span><span style={{ marginLeft: "8px" }}>____________</span></li>
						</ol>

					</div>

				</div>

				<div className="no-break" style={{ border: "2px solid black", textAlign: "left", padding: "4px" }}>
					<h5 style={{ textDecoration: "underline", marginLeft: "8px", fontWeight: "bold" }}>NOTES</h5>
					<div style={{ padding: "8px 16px" }}>__________________________________________________________________________________________________________________________________________________________________________________________</div>
					<div style={{ padding: "8px 16px" }}>__________________________________________________________________________________________________________________________________________________________________________________________</div>
					<div style={{ padding: "8px 16px" }}>__________________________________________________________________________________________________________________________________________________________________________________________</div>
				</div>

				<TestBox testnumber={"1A - Inlet"} percentage={"100"} />
				<TestBox testnumber={"1B - Outlet"} percentage={"100"} />
				<TestBox testnumber={"2A - Outlet"} percentage={"75"} />
				<TestBox testnumber={"2B - Outlet"} percentage={"75"} />
				<TestBox testnumber={"3A - Outlet"} percentage={"50"} />
				<TestBox testnumber={"3B - Outlet"} percentage={"50"} />
				<TestBox testnumber={"4A - Outlet"} percentage={"25"} />
				<TestBox testnumber={"4B - Outlet"} percentage={"25"} />
				<TestBox testnumber={"5A - Blower Air"} percentage={"0"} />
				<TestBox testnumber={"5B - Blower Air"} percentage={"0"} />


				<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", marginTop: "24px" }}>
					<h5><i>Test Approved By: ________________</i></h5>
					<h5><i>Test Completed By: ________________</i></h5>
					<h5><i>Date Completed: ________________</i></h5>
				</div>

				<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", marginTop: "24px" }}>
					<h5><i>Digitally Recorded By: ________________</i></h5>
					<h5><i>Digitally Recorded On: ________________</i></h5>
				</div>

			</div>

		</>
	);
}

export default EductorBlank;